import { OmitStrict } from "@amx/ux-twoui-utils";
import React from "react";
import { Persona, PersonaProps } from "../../../../Persona/Persona";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { Text } from "../../../../Text/Text";
import { TruncatedText } from "../../../../TruncatedText/TruncatedText";
import { TextTitleColumnProps } from "../TextTitleColumn/TextTitleColumn";

export interface PersonaTitleColumnProps extends OmitStrict<TextTitleColumnProps, "isTitleSemiBold"> {
    /**
     * Persona props to create a persona element.
     */
    readonly personaProps: OmitStrict<PersonaProps, "text">;
}

export const PersonaTitleColumn: React.FC<PersonaTitleColumnProps> = ({
    personaProps,
    title,
    subtitles = [],
    disabled,
    truncatedTitleTextProps,
    truncatedSubtitleTextProps
}) => {
    const padding = "4px 0 4px 0";
    const childrenGap=10;

    return (
        <Stack verticalAlign="center" horizontal={true} padding={padding} childrenGap={childrenGap}>
            <Stack height={personaProps.size} width={personaProps.size}> <Persona {...personaProps} text={title} hideText={true} /> </Stack>
            <Stack>
                {truncatedTitleTextProps ? (
                    <TruncatedText
                        lines={truncatedTitleTextProps.lines}
                        stopPropagation={truncatedTitleTextProps.stopPropagation}
                        children={title}
                        disabled={disabled}
                    />
                    ) :
                    <Text children={title} disabled={disabled} />
                }

                {subtitles.map((subtitle, index) =>
                    truncatedSubtitleTextProps ? (
                        <TruncatedText
                            lines={truncatedSubtitleTextProps.lines}
                            stopPropagation={truncatedSubtitleTextProps.stopPropagation}
                            {...subtitle}
                            disabled={disabled}
                            key={index}
                        />
                    ) :
                    <Text {...subtitle} disabled={disabled} key={index} />
                )}
            </Stack>
        </Stack>
    );
};
